var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "card with-triangle bottom margin-bottom-2xl",
          staticStyle: { "--triangle-color": "var(--fa-navy)" },
        },
        [
          _c("div", { staticClass: "header padding-x-xl padding-y-lg" }, [
            _vm.isActivePro && !_vm.isActiveProPlus
              ? _c(
                  "h3",
                  {
                    staticClass: "text-uppercase text-nowrap margin-bottom-2xs",
                    style: `letter-spacing: var(--letter-spacing-2xl); color: var(--fa-teal); font-weight: var(--font-weight-black)`,
                  },
                  [_vm._v("\n        New Pro+ Packs\n      ")]
                )
              : _c(
                  "h3",
                  {
                    staticClass: "text-uppercase text-nowrap margin-bottom-2xs",
                    style: `letter-spacing: var(--letter-spacing-2xl); color: var(--fa-teal); font-weight: var(--font-weight-black)`,
                  },
                  [_vm._v("\n        Font Awesome 7\n      ")]
                ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "strong",
                staticStyle: { "font-size": "var(--font-size-lg)" },
              },
              [_vm._v("\n        Now Available!\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isActiveProPlus
        ? _c(
            "div",
            {
              staticClass:
                "disabled button flat block margin-bottom-2xl with-border",
              staticStyle: {
                "--button-disabled-opacity": "1",
                "--button-disabled-background": "var(--fa-lt-gravy)",
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: _vm.$v7.solid.faPartyHorn, size: "lg" },
              }),
              _vm._v("\n    You've got a Pro+ Plan!\n  "),
            ],
            1
          )
        : _c(
            "site-link",
            {
              staticClass: "button teal block margin-bottom-2xl",
              attrs: { to: { name: "plans" } },
              nativeOn: {
                click: function ($event) {
                  return _vm.purchaseFlowEvent("v7preorder_button_click", {
                    context: "home_view",
                    location: "hero",
                  })
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v7.solid.faClock, size: "xl" },
              }),
              _vm._v("\n    Upgrade to Pro+\n  "),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isBacker && !_vm.isActivePro
        ? _c(
            "site-link",
            {
              staticClass: "button block margin-bottom-2xl",
              attrs: { to: { name: "account" } },
              nativeOn: {
                click: function ($event) {
                  return _vm.purchaseFlowEvent("your_kits_button_click", {
                    context: "home_view",
                    location: "hero",
                  })
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v7.solid.faUserCircle, size: "lg" },
              }),
              _vm._v("\n    Your Account\n  "),
            ],
            1
          )
        : _vm.hasAccount
        ? _c(
            "site-link",
            {
              staticClass: "button block margin-bottom-2xl",
              attrs: { to: { name: "kits" } },
              nativeOn: {
                click: function ($event) {
                  return _vm.purchaseFlowEvent("your_kits_button_click", {
                    context: "home_view",
                    location: "hero",
                  })
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v7.solid.faSuitcase, size: "lg" },
              }),
              _vm._v("\n    Your Kits\n  "),
            ],
            1
          )
        : _c(
            "site-link",
            {
              staticClass: "button block margin-bottom-2xl",
              attrs: { to: { name: "start" } },
              nativeOn: {
                click: function ($event) {
                  return _vm.purchaseFlowEvent("start_for_free_button_click", {
                    context: "home_view",
                    location: "hero",
                  })
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-sm",
                attrs: { icon: _vm.$v7.solid.faGlobe, size: "lg" },
              }),
              _vm._v("\n    Start for Free\n  "),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isActiveProPlus
        ? _c(
            "p",
            { staticClass: "tablet:size-sm text-center margin-bottom-2xl" },
            [
              _vm._v(
                "\n    With your Pro+ plan, you have access to all of Font Awesome 7, including our new Pro+ icon packs, custom icons, and other services.\n  "
              ),
            ]
          )
        : _vm.isProMax
        ? _c(
            "p",
            { staticClass: "tablet:size-sm text-center margin-bottom-2xl" },
            [
              _vm._v(
                "\n    Upgrade to Pro Max+ to get access to the new FA 7 Pro+ icon packs, along with even more services and bandwidth.\n  "
              ),
            ]
          )
        : _vm.isActivePro
        ? _c(
            "p",
            { staticClass: "tablet:size-sm text-center margin-bottom-2xl" },
            [
              _vm._v(
                "\n    Upgrade to Pro+ to get access to the new FA 7 Pro+ icon packs, along with more services and bandwidth.\n  "
              ),
            ]
          )
        : _c(
            "p",
            { staticClass: "tablet:size-sm text-center margin-bottom-2xl" },
            [
              _vm._v(
                "\n    Get a Font Awesome Pro subscription to access version 7 - or go Pro+ and get our new Pro+ icon packs, plus more services and bandwidth.\n  "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }